<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>客户档案</el-breadcrumb-item>
            <el-breadcrumb-item>档案列表</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align: left">
        <el-col :span="6">
          <el-input
            placeholder="搜索客户名称/账户名称/账户ID"
            v-model="customerProfile.name"
            size="small"
            class="input-with-select"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="EventChangeSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="17" style="margin-left: 10px">
          <el-button type="primary" size="small" @click="Refresh" plain
            >刷新</el-button
          >
          <!-- <el-button type="primary" size="small" plain @click="EventAddCust">添加客户</el-button> -->
          <el-button
            type="success"
            size="small"
            plain
            @click="EventExportAll"
            v-if="customerProfile.isall === 'all'"
            >导出客户信息</el-button
          >
          <!-- <el-button
            type="primary"
            size="small"
            plain
            @click="upDialog = true"
            v-if="customerProfile.isall === 'all'"
            >导入客户信息</el-button
          > -->
          <el-button
            type="primary"
            size="small"
            plain
            @click="ScoreVisible = true"
            >评分细则</el-button
          >
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-table
          :data="tableData.DataList"
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="优化师:" v-if="Info.admin === 'true'">
                  <span>{{ props.row.UserName }}</span>
                </el-form-item>
                <el-form-item label="工号:" v-if="Info.admin === 'true'">
                  <span>{{ props.row.UserId }}</span>
                </el-form-item>
                <el-form-item label="中心:" v-if="Info.admin === 'true'">
                  <span>{{ props.row.CenterName }}</span>
                </el-form-item>
                <el-form-item label="部门:" v-if="Info.admin === 'true'">
                  <span>{{ props.row.DeptsName }}</span>
                </el-form-item>
                <el-form-item label="客户ID:">
                  <span>{{ props.row.AdvertiserID }}</span>
                </el-form-item>
                <el-form-item label="客户名称:">
                  <span>{{ props.row.Name }}</span>
                </el-form-item>
                <!-- <el-form-item label="类型:">
                  <span>{{ props.row.Grade }}</span>
                </el-form-item> -->
                <el-form-item label="账户ID:">
                  <span>{{ props.row.AccountID }}</span>
                </el-form-item>
                <el-form-item label="账户名称:">
                  <span>{{ props.row.AccountName }}</span>
                </el-form-item>
                <!-- <el-form-item label="注册时间:">
                  <span>{{ props.row.RegisterTime }}</span>
                </el-form-item> -->
                <el-form-item label="开户时间:">
                  <span>{{ props.row.CooperateTime }}</span>
                </el-form-item>
                <el-form-item label="账户首次消费日:">
                  <span>{{ props.row.FirstSpendTime }}</span>
                </el-form-item>
                <!-- <el-form-item label="账户状态:">
                  <span>{{ props.row.Status }}</span>
                </el-form-item>
                <el-form-item label="合规信用值:">
                  <span>{{ props.row.CreditScore }}</span>
                </el-form-item> -->
                <el-form-item label="SF对应二级账号:">
                  <span>{{ props.row.SFAccount }}</span>
                </el-form-item>
                <el-form-item label="上月消费日均:">
                  <span>{{ props.row.MonthlyBudget }}</span>
                </el-form-item>
                <!-- <el-form-item label="行业类目:">
                  <span
                    >{{ props.row.Industry1 }} / {{ props.row.Industry2 }}</span
                  >
                </el-form-item> -->
                <el-form-item label="公司性质:">
                  <span>{{ props.row.Nature }}</span>
                </el-form-item>
                <el-form-item label="公司人员规模:">
                  <span>{{ props.row.Scale }}</span>
                </el-form-item>
                <el-form-item label="公司架构:">
                  <span>{{ props.row.Structure }}</span>
                </el-form-item>
                <el-form-item label="主要经营产品:">
                  <span>{{ props.row.MainBusiness }}</span>
                </el-form-item>
                <el-form-item label="产品售价/特征:">
                  <span>{{ props.row.ProductProperties }}</span>
                </el-form-item>
                <el-form-item label="公司是否上市:">
                  <span>{{ props.row.IsIPO }}</span>
                </el-form-item>
                <el-form-item label="客户年营业额:">
                  <span>{{ props.row.AnnualTurnover }}</span>
                </el-form-item>
                <el-form-item label="客户年广告预算:">
                  <span>{{ props.row.AnnualAdBudget }}</span>
                </el-form-item>
                <el-form-item label="投放各个平台预算:">
                  <span>{{ props.row.PlatformBudget }}</span>
                </el-form-item>
                <el-form-item label="重要营销月份及节点:">
                  <span>{{ props.row.MarketingNodes }}</span>
                </el-form-item>
                <el-form-item label="客户主要营销诉求:">
                  <span>{{ props.row.MarketingAppeal }}</span>
                </el-form-item>
                <el-form-item label="公司周年庆/老板生日:">
                  <span>{{ props.row.Anniversary }}</span>
                </el-form-item>
                <el-form-item label="关键人1(职级):">
                  <span>{{
                    props.row.Contact1 + "(" + props.row.Grade1 + ")"
                  }}</span>
                </el-form-item>
                <el-form-item label="关键人2(职级):">
                  <span>{{
                    props.row.Contact2 + "(" + props.row.Grade2 + ")"
                  }}</span>
                </el-form-item>
                <el-form-item label="关键人3(职级):">
                  <span>{{
                    props.row.Contact3 + "(" + props.row.Grade3 + ")"
                  }}</span>
                </el-form-item>
                <el-form-item label="客户当前投放情况简介:">
                  <span>{{ props.row.CurrentPutDesc }}</span>
                </el-form-item>
                <el-form-item label="客户竞争对手1:">
                  <span>{{ props.row.Competitor }}</span>
                </el-form-item>
                <el-form-item label="竞争对手1投放情况:">
                  <span>{{ props.row.PutDesc }}</span>
                </el-form-item>
                <el-form-item label="客户竞争对手2:">
                  <span>{{ props.row.Competitor2 }}</span>
                </el-form-item>
                <el-form-item label="竞争对手2投放情况:">
                  <span>{{ props.row.PutDesc2 }}</span>
                </el-form-item>
                <el-form-item label="客户竞争对手3:">
                  <span>{{ props.row.Competitor3 }}</span>
                </el-form-item>
                <el-form-item label="竞争对手3投放情况:">
                  <span>{{ props.row.PutDesc3 }}</span>
                </el-form-item>
                <el-form-item label="当月线索量:">
                  <span>{{ props.row.CurrentClueQuantity }}</span>
                </el-form-item>
                <el-form-item label="当月线索成本:">
                  <span>{{ props.row.CurrentClueCost }}</span>
                </el-form-item>
                <el-form-item label="当月线索有效率:">
                  <span>{{ props.row.CurrentClueEfficient }}</span>
                </el-form-item>
                <el-form-item label="行业成本:">
                  <span>{{ props.row.IndustryCost }}</span>
                </el-form-item>
                <el-form-item label="适配品牌产品:">
                  <span>{{ props.row.BrandProducts }}</span>
                </el-form-item>
                <el-form-item label="预计到款时间:">
                  <span>{{ props.row.ExpectedPayTime }}</span>
                </el-form-item>
                <el-form-item label="预计到款金额:">
                  <span>{{ props.row.ExpectedPayAmount }}</span>
                </el-form-item>
                <el-form-item label="跟进卡点:">
                  <span>{{ props.row.FollowQuestion }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            label="客户名称"
            prop="Name"
            width="360"
          ></el-table-column>
          <el-table-column
            label="账户名称"
            prop="AccountName"
            width="250"
          ></el-table-column>
          <el-table-column label="账户ID" prop="AccountID"> </el-table-column>
          <el-table-column label="优化师" prop="UserName"> </el-table-column>
          <el-table-column label="工号" prop="UserId"></el-table-column>
          <el-table-column
            label="操作"
            width="425"
            class-name="btnbox"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                size="small"
                @click="EventTableClick(scope.row, 'edit')"
                >编辑</el-button
              >
              <el-button
                type="primary"
                plain
                size="small"
                @click="EventTableClick(scope.row, 'replay')"
                >出访复盘</el-button
              >
              <el-button
                type="primary"
                plain
                size="small"
                @click="EventTableClick(scope.row, 'optimize')"
                >推广提案</el-button
              >
              <el-button
                type="primary"
                plain
                size="small"
                @click="EventTableClick(scope.row, 'diagnose')"
                >优化诊断</el-button
              >
              <el-button
                type="primary"
                plain
                size="small"
                v-if="customerProfile.isall === 'all'"
                @click="EventTableClick(scope.row, 'mark')"
                >评分</el-button
              >
              <!-- <el-button
                type="danger"
                plain
                size="small"
                @click="EventTableClick(scope.row, 'delete')"
                v-if="customerProfile.isall === 'all'"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!-- 分页 -->
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="customerProfile.PageIndex"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="customerProfile.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.TotalCount"
            style="float: right"
          ></el-pagination>
        </el-col>
      </el-row>
      <!-- 编辑 添加 -->
      <DiaLog
        :industry="options"
        :Info="Info"
        :dialogTitle="dialogTitle"
        :visible="visible"
        :customerSingle="customerSingle"
        @close="EventCloseDialog"
        @changeForm="eventChangeForm"
        @submit="EventSubmitForm"
      ></DiaLog>
      <!-- 评分细则 -->
      <el-dialog title="评分细则" :visible.sync="ScoreVisible" width="50%">
        <el-table :data="ScoreDescList" style="width: 100%">
          <el-table-column label="指标类目" prop="Type"> </el-table-column>
          <el-table-column label="指标名称" prop="Name"> </el-table-column>
          <el-table-column label="指标说明" prop="Info" width="200">
          </el-table-column>
          <el-table-column label="检验细则" width="400">
            <template slot-scope="scope">
              <el-row v-for="(item, index) in scope.row.Detail" :key="index">
                <el-col>{{ item }}</el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="ScoreVisible = false">取 消</el-button>
          <el-button type="primary" @click="ScoreVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 推广提案 -->
      <el-dialog title="推广提案" :visible.sync="optimizeVisible" width="50%">
        <div class="block">
          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in optimizeList"
              :key="index"
              placement="top"
              :timestamp="item.AddTime"
            >
              <i class="el-icon-folder-opened"></i>
              <el-button type="text" @click="delxlsx(item.Id)">删除</el-button>
            </el-timeline-item>
            <el-timeline-item>
              <div class="upbox">
                <el-upload
                  class="upload-demo"
                  action="http://eapi.ruizhiqi.cn/api/upload/uploadformdata"
                  size="small"
                  :limit="1"
                  :file-list="fileList"
                  :before-upload="checkFile"
                  :on-success="upload2"
                  :on-error="uploaderror"
                >
                  <el-button size="small" type="primary" class="upbtn"
                    >上传文件</el-button
                  >
                </el-upload>
                <p class="tl cr">
                  内容包括不限于市场分析、整体数据呈现、优化诊断、后期投放策略
                </p>
                <p class="tl cr">每月至少上传1份推广提案，定期评选优秀案例</p>
                <p class="tl">支持扩展名：.rar .zip .doc .docx .ppt...</p>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="optimizeVisible = false">取 消</el-button>
          <el-button type="primary" @click="Addoptimize">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 导入客户信息 -->
      <el-dialog
        title="导入客户信息"
        :visible.sync="upDialog"
        width="40%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <h5>说明：</h5>
        <p>1、请严格按照模板格式进行填写数据，否则可能导入失败；</p>
        <!-- <p>2、填写的数据中不可出现空格和换行符；</p> -->
        <div class="upbox">
          <h5>选择EXCEL文件：</h5>
          <el-upload
            class="upload-demo2"
            action="http://eapi.ruizhiqi.cn/api/upload/uploadformdata"
            :limit="1"
            :disabled="isupok"
            :before-upload="checkFile"
            :on-success="upAllEXCEL"
            :on-error="uploaderror"
          >
            <el-button size="small" type="primary" class="upbtn"
              >选择文件</el-button
            >
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            size="small"
            type="primary"
            v-if="uploadfile != ''"
            :disabled="isupok"
            :loading="isupok"
            @click="goUp"
            >确定上传</el-button
          >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
/**
 * API接口内容
 * */

import {
  GetCustomerProfile,
  GetCustomerInfo,
  DeleteCustomerProfile,
  MaintainCustomerDoc,
  ExportAllCustomer,
  getIndustryList,
  getCustomerDetail,
  addCustomerDetail,
  delCustomerDetail,
  AddCustomer,
} from "@/until/ZeusApiSDK/Logic/CustomerProfile";
/**
 * 用户信息API接口
 * */

import {
  GetCurrentUserInfo,
  GetCurrentUserRole,
} from "@/until/ZeusApiSDK/Logic/HomeLogic";
/**
 * 组件内容
 * */
import DiaLog from "@/views/CustomerProfile/components/custDialog.vue";
export default {
  components: { DiaLog },
  data() {
    return {
      loading: false,
      visible: false,
      dialogTitle: "",
      customerSingle: {},
      customerProfile: {
        ucode: "",
        isall: "",
        pageIndex: 1,
        pageSize: 10,
        name: "",
      },
      tableData: {
        DataList: [],
        TotalCount: 0,
      },
      options: [],
      Info: GetCurrentUserInfo(),
      // 批量导入
      isupok: false,
      upDialog: false,
      uploadfile: "",
      // 推广提案
      optimizeVisible: false,
      optimizeList: [],
      customerid: "",
      fileList: [],
      optimizefile: "",
      // 评分细则
      ScoreVisible: false,
      ScoreDescList: [
        {
          Type: "服务规范",
          Name: "客户档案更新",
          Info: "对所维护的客户定期更新档案信息",
          Detail: [
            "1、所维护的客户，在E平台中定期更新客户档案信息",
            "2、档案信息包含账户情况（投入/期望）/客户推广团队/公司规模等",
            "3、最终得分=更新客户数/维护客户数*100%",
          ],
        },
        {
          Type: "",
          Name: "客户出访复盘",
          Info: "对所维护客户进行出访",
          Detail: [
            "1、A层客户每月一次客户出访，B层客户每两个月一次客户出访，C类客户每季度一次客户出访",
            "2、最终得分=要求出访客户数/维护客户数*100%",
          ],
        },
        {
          Type: "",
          Name: "",
          Info: "对所维护客户进行当面复盘",
          Detail: [
            "1、以报表形式向客户进行数据达成情况对齐",
            "2、A层客户每月一次客户当面复盘，B层客户每两个月一次客户当面复盘，C类客户每季度一次客户当面复盘；复盘内容：上月线索量，线索成本，有效率数据目标达成情况，确定下月消费目标及线索量，线索成本，有效率目标值；",
            "3、完成得满分，每少完成1项扣2分",
          ],
        },
        {
          Type: "业务专业",
          Name: "推广提案",
          Info: "对所维护的客户进行市场分析",
          Detail: [
            "1、A层客户双周一次市场分析，B层客户每月一次市场分析，C/D客户每两个月一次市场分析",
            "2、市场分析以文字形式沉淀，重点分析客户行业以及行业竞争格局",
            "3、完成得满分，每少完成1个客户扣2分",
          ],
        },
        {
          Type: "",
          Name: "",
          Info: "对所维护的A/B层客户制作推广提案报告",
          Detail: [
            "1、以PPT形式向客户进行推广总结及规划对齐",
            "2、A层客户每月一次制作推广提案PPT，B层客户每两个月一次制作推广提案PPT",
            "3、完成得满分，每少完成1个客户扣5分",
          ],
        },
        {
          Type: "",
          Name: "优化诊断",
          Info: "对所维护的客户进行优化问题的诊断",
          Detail: [
            "1、定期为客户做账户诊断，并给出优化建议",
            "2、A层客户每周一次优化诊断，B层客户每双周一次优化诊断，C/D客户每月一次优化诊断",
            "3、根据后台历史操作记录以及优化诊断反馈表，评估账户优化情况",
            "4、完成得满分，每少完成1个客户扣2分",
          ],
        },
        {
          Type: "客户调研",
          Name: "客户满意度",
          Info: "取所维护的客户季度满意度调研平均分",
          Detail: ["最终得分=当季度客户满意度调研平均分*5%"],
        },
      ],
    };
  },
  created() {
    GetCurrentUserRole().then((res) => {
      let Info = GetCurrentUserInfo();
      this.customerSingle.UserId = Info.UserCode;
      this.customerSingle.UserName = Info.TrueName;
      this.customerProfile.isall = "one";
      this.customerProfile.ucode = Info.UserCode;
      this.customerSingle.Id = res.Id;
      if (res.Key == "admin" || res.Key == "cusprofile") {
        this.Info.admin = "true";
        this.customerProfile.isall = "all";
      }
      if (res.Key == "director") {
        this.customerProfile.isall = "centre";
      }
      if (res.Key == "Manager") {
        this.customerProfile.isall = "department";
      }
      this.APIGetCustomerProfile(this.customerProfile);
      //this.APIgetIndustryList();
    });
  },
  methods: {
    // 获取客户档案列表API
    APIGetCustomerProfile(prams) {
      this.loading = true;
      GetCustomerProfile(prams)
        .then((res) => {
          this.loading = false;
          this.tableData.DataList = res.DataList;
          this.tableData.TotalCount = res.TotalCount;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    APIDeleteCustomerProfile(param) {
      this.loading = true;
      DeleteCustomerProfile(param)
        .then(() => {
          this.loading = false;
          this.$message({
            message: "删除成功!",
            type: "success",
          });
          this.APIGetCustomerProfile(this.customerProfile);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    APIMaintainCustomerDoc(param) {
      param.MarketingNodes = param.MarketingNodes.toString();
      this.loading = true;
      MaintainCustomerDoc(param)
        .then(() => {
          this.loading = false;
          this.$message({
            message: `${param.Id === "" ? "新增" : "修改"}成功!`,
            type: "success",
          });
          this.EventCloseDialog();
          this.APIGetCustomerProfile(this.customerProfile);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    APIgetIndustryList() {
      getIndustryList().then((res) => {
        this.options = res;
      });
    },
    /**
     * 翻页相关事件
     * */
    handleSizeChange(e) {
      this.customerProfile.pageSize = e;
      this.APIGetCustomerProfile(this.customerProfile);
    },
    handleCurrentChange(e) {
      this.customerProfile.pageIndex = e;
      this.APIGetCustomerProfile(this.customerProfile);
    },
    /**
     * 表格相关事件
     * */
    EventTableClick(row, eventName) {
      switch (eventName) {
        case "edit":
          this.visible = true;
          this.dialogTitle = "编辑客户档案";
          GetCustomerInfo({ infoid: row.AccountID })
            .then((res) => {
              row = res;
              Array.isArray(row.MarketingNodes)
                ? row.MarketingNodes
                : (row.MarketingNodes =
                    row.MarketingNodes === "" || row.MarketingNodes == null
                      ? new Array()
                      : row.MarketingNodes.split(","));
              row.IsIPO = row.IsIPO === "是" ? true : false;
              //row.Industry = [row.Industry1, row.Industry2];
              this.customerSingle = JSON.parse(JSON.stringify(row));
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case "delete":
          this.$confirm("此操作不可恢复, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.APIDeleteCustomerProfile(row.Id);
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
          break;
        // 出访复盘
        case "replay":
          if (row.Id == null) {
            this.$message({
              message: "请先更新客户基本资料信息",
              type: "warning",
            });
            return false;
          }
          this.$router.push({
            path: `/Customer/Replay/${row.Id}`,
          });
          break;
        // 推广提案
        case "optimize":
          if (row.Id == null) {
            this.$message({
              message: "请先更新客户基本资料信息",
              type: "warning",
            });
            return false;
          }
          this.optimizefile = "";
          this.customerid = row.Id;
          var paras = {
            type: "2",
            customerid: row.Id,
            isall: "all",
            pageIndex: "1",
            pageSize: "5",
            name: "all",
            time: "",
          };
          getCustomerDetail(paras).then((res) => {
            this.optimizefile = "";
            this.fileList = [];
            this.optimizeVisible = true;
            this.optimizeList = res.DataList;
          });
          break;
        // 优化诊断
        case "diagnose":
          if (row.Id == null) {
            this.$message({
              message: "请先更新客户基本资料信息",
              type: "warning",
            });
            return false;
          }
          this.$router.push({
            path: `/Customer/Diagnoselist/${row.Id}`,
          });
          break;
        // 评分
        case "mark":
          if (row.Id == null) {
            this.$message({
              message: "客户基本资料信息未完善，不能评分",
              type: "warning",
            });
            return false;
          }
          this.$router.push({
            path: `/Customer/CustomerMark/${row.Id}`,
          });
          break;
        default:
          break;
      }
    },
    /**
     * 表头按钮事件
     * */
    // 刷新按钮
    Refresh() {
      this.customerProfile.name = "";
      this.APIGetCustomerProfile(this.customerProfile);
    },
    // 新增用户表单
    EventAddCust() {
      this.visible = true;
      this.customerSingle.Id = "";
      this.dialogTitle = "新增客户档案";
      this.customerSingle = {
        UserName: this.Info.TrueName,
        UserId: this.Info.UserCode,
        Id: "",
        MarketingNodes: [],
        IsIPO: false,
        IsFinancing: false,
      };
    },
    // 导入
    upAllEXCEL(e) {
      this.uploadfile = e.Data.Message;
    },
    goUp() {
      var paras = {
        path: this.uploadfile,
      };
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
      });
      this.isupok = true;
      this.loading = true;
      AddCustomer(paras)
        .then((res) => {
          this.$message({
            message: `导入成功!`,
            type: "success",
          });
          loading.close();
          this.isupok = false;
          this.upDialog = false;
          this.customerProfile.pageSize = 10;
          this.APIGetCustomerProfile(this.customerProfile);
          this.loading = false;
        })
        .catch((err) => {
          loading.close();
          this.isupok = false;
          this.loading = false;
          err = JSON.parse(err);
          this.$message({
            message: err.Data.Message,
            type: "error",
          });
        });
    },
    // 导出全部表单
    EventExportAll() {
      const a_link = document.createElement("a"); // 创建a标签
      a_link.setAttribute("download", ExportAllCustomer()); // download属性
      a_link.setAttribute("href", ExportAllCustomer()); // href链接
      a_link.setAttribute("target", "_self"); // href链接
      a_link.setAttribute("class", "downA"); // href链接
      a_link.click(); // 自执行点击事件
    },
    // 关闭模态窗口
    EventCloseDialog() {
      this.visible = false;
      this.customerSingle = {};
    },
    // 关闭表单
    eventChangeForm(e) {
      this.customerSingle = {
        ...this.customerSingle,
        ...e,
        Anniversary: "",
      };
    },
    // 提交表单
    EventSubmitForm() {
      this.UtilFormatSubmit();
      this.APIMaintainCustomerDoc({
        ...this.customerSingle,
      });
    },
    // 搜索表单
    EventChangeSearch() {
      this.APIGetCustomerProfile(this.customerProfile);
    },
    // 格式化提交内容
    UtilFormatSubmit() {
      this.customerSingle = {
        ...this.customerSingle,
        MarketingNodes: this.customerSingle.MarketingNodes.join(","),
        IsIPO: this.customerSingle.IsIPO === false ? "否" : "是",
        //IsFinancing: this.customerSingle.IsFinancing === false ? "否" : "是",
        //Industry1: this.customerSingle.Industry[0],
        //Industry2: this.customerSingle.Industry[1],
      };
      delete this.customerSingle.Industry;
    },
    checkFile(e) {
      //console.log(e, "------上传文件之前的钩子");
      if (e.size > 10485760) {
        this.$message({
          message: "上传失败,请查看文件是否过大~（推荐上传大小：小于10M）",
          type: "warning",
        });
        return false;
      }
    },
    // 上传推广提案
    upload2(e) {
      //console.log(e);
      if (e.Data.Result == 1) {
        this.optimizefile = e.Data.Message;
      } else {
        this.$message.error(
          e.Data.Message.length > 0 ? e.Data.Message : "上传失败"
        );
      }
    },
    uploaderror(e) {
      this.$message.error(e.Data.Message);
    },
    // 提交推广提案
    Addoptimize() {
      if (this.optimizefile.length == 0) {
        this.$message.error({
          message: "请上传上传推广提案文件",
          type: "warning",
        });
        return false;
      }
      var paras = {
        Id: "",
        CustomerId: this.customerid,
        Type: 2,
        Area: "",
        Address: "",
        Purpose: "",
        Time: "",
        PunchPic: "",
        RecordPic: "",
        ReviewReport: "",
        Approach: "",
        Planning: "",
        Question: "",
        Support: "",
        Proposal: this.optimizefile,
        UserId: this.Info.UserCode,
        UserName: this.Info.TrueName,
      };
      this.loading = true;
      addCustomerDetail(paras)
        .then(() => {
          this.loading = false;
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.optimizeVisible = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    // 删除
    delxlsx(id) {
      this.$confirm("确定删除此优化方案？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var paras = {
            id: id,
          };
          delCustomerDetail(paras).then((res) => {
            this.loading = false;
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.optimizeVisible = false;
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.el-dialog__body {
  padding-bottom: 0;
}
.ticketinfo {
  text-align: left !important;
}
.demo-table-expand {
  font-size: 0;
  padding-left: 60px;
}
.demo-table-expand label {
  width: 160px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.btnbox .el-button {
  margin: 0 10px 10px 0;
}
.upbox {
  margin: 0;
  padding: 0;
  border: 0;
}
.upload-demo {
  text-align: left;
}
::v-deep .upload-demo .el-upload {
  text-align: left !important;
}
.tl {
  text-align: left;
  float: none;
  margin-left: 0;
}
.cr {
  color: #d9001b;
}
.el-icon-folder-opened {
  color: #999;
  font-size: 30px;
}
// .el-timeline-item__node--normal {
//   border: 2px solid #409eff;
// }
::v-deep .el-timeline-item__node {
  background: #fff !important;
  box-sizing: border-box;
  border: 3px solid #409eff;
}
</style>
